import React, { useEffect, useState } from "react";

function durationToMs(value, unit) {
  const v = Number(value) || 0;
  switch (unit) {
    case "Days":
      return v * 24 * 60 * 60 * 1000;
    case "Hours":
      return v * 60 * 60 * 1000;
    case "Minutes":
      return v * 60 * 1000;
    default:
      return v * 24 * 60 * 60 * 1000;
  }
}

export default function SlaWarningBanner({ stage, enteredAt }) {
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    if (!stage || !enteredAt) return;
    const interval = setInterval(() => {
      const now = new Date();
      const entered = new Date(enteredAt);
      const elapsed = now - entered;
      const total = durationToMs(stage.estimatedDuration, stage.durationUnit);
      if (total > 0) {
        const p = Math.floor((elapsed / total) * 100);
        setPercent(p);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [stage, enteredAt]);

  if (
    !stage ||
    !stage.slaWarningThreshold ||
    !stage.estimatedDuration ||
    percent < stage.slaWarningThreshold
  )
    return null;

  return (
    <div className="sla-warning-banner">
      SLA Warning: This stage has used {percent}% of its estimated time
    </div>
  );
}
